import { observer } from "mobx-react-lite";
import Notifications from "./Notifications";
import Security from "./Security";
import Users from "./Users";
import { Box, Typography, useColorScheme } from "@mui/material";
import { useEffect, useState } from "react";
import TabsWidget from "../widgets/tabs_widget";
import { Constants } from "../../utils/constants";

function Setting({ jobStore, authStore }) {
  useEffect(() => {
    jobStore.setNavigation("setting");
  }, [jobStore]);

  const user = authStore.user;
  const { mode } = useColorScheme();
  const currentMode = mode || "system";
  const [value, setValue] = useState("notifications");
  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems(user && user.user_id && user.org && user.user_id === user.org.main_user ? Constants.AdminTabs : Constants.AdminTabs);
  }, [user]);

  const onChange = (newValue) => {
    setValue(newValue);
  };

  return (
    <Box>
      <Box>
        <Typography fontWeight={Constants.Styles.fontWeight.semiBold} fontSize={Constants.Styles.fontSize["2xl"]}>
          Settings
        </Typography>
        <Typography fontSize={Constants.Styles.fontSize.sm} fontWeight={400} color={Constants.Colors.light.mutedForeground}>
          Manage your account preferences and team
        </Typography>
      </Box>
      <Box
        sx={{
          my: "1.5rem",
        }}
      >
        <TabsWidget
          items={items}
          value={value}
          onChange={onChange}
        />
      </Box>
      {value === "notifications" && <Notifications jobStore={jobStore} />}
      {value === "security" && <Security jobStore={jobStore} />}
      {value === "users" && <Users jobStore={jobStore} authStore={authStore} />}
    </Box>
  );
}

export default observer(Setting);
